import { ESortOrder } from '../../enums';

export interface ISortParams {
  orderByField?: string;
  orderBy?: ESortOrder | null;
}
